export default __webpack_public_path__ + "static/media/C0002.a46856c0.png";